import { Component } from '@angular/core';

@Component({
  selector: 'app-examNotFinished',
  templateUrl: './examNotFinished.component.html',
})
export class ExamNotFinishedComponent {

  redrectToElsoWebste() {
    window.location.href = 'https://elso.org';
  }
}
